import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/general/toolsReportActions'
import { Button, Form, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/general/tools/ListItems'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const propTypes = {}
const FormItem = Form.Item

class ToolsReportContainer extends Component {
  constructor(props) {
    super(props)

    // get tools list
    this.props.toolsReportGetEmployeesList({})
  }

  onEmployeesSearch = _.debounce(value => {
    this.props.toolsReportGetEmployeesList({
      filters: {
        name: value
      }
    })
  }, 500)

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.toolsReportGetFullReport({ filters: values })
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/general/tools-report/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const employeesListData = _.get(this.props, 'toolsReportActions.employeesList.data')
    const loadingEmployeesList = _.get(this.props, 'toolsReportActions.loadingEmployeesList')

    const loadingFullReport = _.get(this.props, 'toolsReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'toolsReportActions.fullReport.data')

    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Tools Report</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-6">
                  <Spin spinning={loadingEmployeesList}>
                    <FormItem label="Employee">
                      {getFieldDecorator('employee_id', {})(
                        <AutoComplete
                          dataSource={convertToOption(employeesListData)}
                          onChange={this.onEmployeesSearch}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for an Employee"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ toolsReportActions, authentication }, ownProps) => ({
  toolsReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

ToolsReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(ToolsReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/general/ToolsReportContainer.js